import type { IAttributes, IDirective } from "angular";
import { isDefined, module } from "angular";
import "@progress/kendo-ui/js/kendo.switch";

export default class InputToggleDirective implements IDirective {
    public priority = 1000;

    public restrict = "E";

    public scope = {
        irLabel: "<",
        ngModel: "=",
        noText: "<?",
        yesText: "<?",
    };

    public template: string;

    constructor() {
        const randomId = `${Math.random().toString(36)}00000000000000000`.slice(2, 10);
        this.template = `
            <div class="form-group">
                <label for="${randomId}" class="control-label">{{irLabel | translate}}</label>
                <div>
                    <input type="checkbox" kendo-switch k-ng-model="ngModel"
                            id="${randomId}" class="form-control"
                            on-label="yesText | translate" off-label="noText | translate" />
                </div>
            </div>`;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public link(scope: any, instanceElement: JQuery, instanceAttributes: IAttributes, controller?: any) {
        if (!isDefined(scope.yesText)) {
            scope.yesText = "Gui.Common.Yes";
        }
        if (!isDefined(scope.noText)) {
            scope.noText = "Gui.Common.No";
        }
    }
}

module("mmGui").directive("irInputToggle", () => new InputToggleDirective());
